<div>
  <div *ngIf="themesFound()">
    <div *ngFor="let theme of themesData; trackBy: trackByThemeId"
         class="flex flex-col md:flex-row md:items-start md:gap-6 mb-8 mt-8">
      <div class="theme-image flex-shrink-0 w-full md:w-1/3">
        <img
          [src]="theme.currentImageSrc"
          alt="Theme Image"
          class="w-full h-auto rounded shadow"
          width="295"
          height="220"
          (error)="handleImageError(theme)"
        /></div>
      <div class="theme-details w-full md:w-2/3">
        <table class="w-full">
          <tr class="border-b border-slate-100 dark:border-slate-700">
            <td class="text-left font-bold p-1 w-40">Theme Slug</td>
            <td class="p-1">{{ theme.name }}</td>
          </tr>
          <tr class="border-b border-slate-100 dark:border-slate-700">
            <td class="text-left font-bold p-1 w-40">Theme Url</td>
            <td class="p-1">{{ theme.path }}</td>
          </tr>
          <tr
            *ngIf="theme.version"
            class="border-b border-slate-100 dark:border-slate-700">
            <td class="text-left font-bold p-1 w-40">Version</td>
            <td class="p-1">{{ theme.version }}</td>
          </tr>
          <tr class="border-b border-slate-100 dark:border-slate-700">
            <td class="text-left font-bold p-1 w-40">Is Child</td>
            <td class="p-1">{{ theme.isChild }}</td>
          </tr>
          <tr *ngIf="theme.parentTheme" class="border-b border-slate-100 dark:border-slate-700">
            <td class="text-left font-bold p-1 w-40">Parent Theme</td>
            <td class="p-1">{{ theme.parentTheme }}</td>
          </tr>
          <tr *ngIf="theme.parentTheme" class="border-b border-slate-100 dark:border-slate-700">
            <td class="text-left font-bold p-1 w-40">Newest Version</td>
            <td class="p-1">{{ theme.newVersion }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
  <div *ngIf="!themesFound()">
    <div class="flex justify-center items-center h-32">
      <p class="text-lg">We searched for themes references in the page source, and no themes were found.</p>
    </div>
  </div>
</div>
